export const getRatingLabel = (score) => {
  const value = Number(score)
  if (!Number.isFinite(value)) return ''

  if (value >= 9) return 'Excellent'
  if (value >= 8) return 'Very Good'
  if (value >= 7) return 'Good'
  if (value >= 4) return 'Fair'
  return 'Poor'
}
